<div class="continue-button preview-root fullsize-button">
    <div class="preview-container"></div>
    <span class="preview-text"></span>
</div>